import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useRole } from '../../rbac/hooks';
import { tasksListPathForRole } from '../../rbac/tasksListPath';

export function WizardReviewBreadcrumb({ reviewCrumbTo }: { reviewCrumbTo: string }) {
  const { t } = useTranslation();
  const { roleCode } = useRole();

  return (
    <>
      <div className="bc">
        <Link to={tasksListPathForRole(roleCode)}>{t('nav.tasksAndCases')}</Link>
        <span className="bc-sep">/</span>
        <Link to={reviewCrumbTo}>{t('wizard.createCaseRequest')}</Link>
        <span className="bc-sep">/</span>
        {t('wizard.reviewBeforeSubmission')}
      </div>
      <div className="pg-title">{t('wizard.reviewTitle')}</div>
    </>
  );
}

export function WizardReviewSubtitle() {
  const { t } = useTranslation();
  return (
    <div className="pg-sub" style={{ marginBottom: 16 }}>
      {t('wizard.reviewSubtitle')}
    </div>
  );
}

export function WizardReviewConfirm({
  id,
  checked,
  disabled,
  onChange,
  error,
}: {
  id: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  error?: string;
}) {
  const { t } = useTranslation();

  return (
    <div className="confirm-section ccr-review-confirm">
      <label className="ccr-chk" id={id}>
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="ccr-review-confirm-text">
          <span className="ccr-review-confirm-main">
            {t('wizard.confirm.main')} <span className="req">*</span>
          </span>
          <span className="ccr-review-confirm-hint">{t('wizard.confirm.hint')}</span>
        </span>
      </label>
      {error ? <div className="ccr-review-confirm-err">{error}</div> : null}
    </div>
  );
}
